module.exports = __webpack_public_path__ + "static/media/button.91f4413f.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/button.md
// module id = 364
// module chunks = 0